import React, { Component } from "react";

import CommunityContentActivities from "./activities";
import CommunityContentDocs from "./docs";
import CommunityContentForum from "./forum";
import CommunityContentForums from "./forums";
import CommunityContentLives from "./lives";
import CommunityContentNotices from "./notices";
import CommunityContentPlans from "./plans";
import CommunityContentRecordings from "./recordings";
import CommunityContentTrails from "./trails";
import CommunityContentUsers from "./users";

import "./styles.css";

class CommunityContent extends Component {
  render() {
    const content = this.props.content.toLowerCase();
    return (
      <>
        {content === "docs" ? (
          <CommunityContentDocs {...this.props} />
        ) : content === "activities" ? (
          <CommunityContentActivities {...this.props} />
        ) : content === "lives" ? (
          <CommunityContentLives {...this.props} />
        ) : content === "forums" ? (
          <CommunityContentForums {...this.props} />
        ) : content === "forumssingleview" ? (
          <CommunityContentForum {...this.props} />
        ) : content === "users" ? (
          <CommunityContentUsers {...this.props} />
        ) : content === "recordings" ? (
          <CommunityContentRecordings {...this.props} />
        ) : content === "trails" ? (
          <CommunityContentTrails {...this.props} />
        ) : content === "plans" ? (
          <CommunityContentPlans {...this.props} />
        ) : (
          <CommunityContentNotices {...this.props} />
        )}
      </>
    );
  }
}

export default CommunityContent;
